import axios from "axios";
import { PagedResult } from "../models/paged-result";
import { UploadImportacionSempre } from "../models/upload-importacion-sempre";

export const IMPORTACIONSEMPRE_URL = `ImportacionSempre`;

export const importacionSempreServices = {
  getList: (queryParams: any) => {
    return axios.get<PagedResult>(`${IMPORTACIONSEMPRE_URL}`, {
      params: queryParams,
    });
  },

  // Importación de prácticas
  importar: function (formData: FormData) {
    return axios.post<UploadImportacionSempre>(`${IMPORTACIONSEMPRE_URL}/upload-file`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
        return percentCompleted;
      },
    });
  },

  descargarPlantilla: function () {
    return axios.get(`${IMPORTACIONSEMPRE_URL}/plantilla`, {
      responseType: 'blob',
    });
  },

  confirmar: function (data: any) {
    return axios.post(`${IMPORTACIONSEMPRE_URL}/confirmar`, { practica: data });
  },

  anular: function (data: any) {
    return axios.post(`${IMPORTACIONSEMPRE_URL}/anular`, data);
  },

  getPrecargaAdminList: (queryParams: any) => {
    return axios.get<PagedResult>(`${IMPORTACIONSEMPRE_URL}/precarga-admin`, {
      params: queryParams,
    });
  },
};
